import React, { useEffect, useState } from "react";
import Logo from "../../../assets/img/custom/logo.png";
import { Label, Input, Button, Form, Spinner } from "reactstrap";
import { Link, Redirect } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { registerSuccess, login } from "store/actions/authActions";
import { useLocation } from "react-router-dom";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  let dispatch = useDispatch();
  const location = useLocation();
  const history = useHistory();
  let auth = useSelector((state) => state.auth);
  useEffect(() => {
    dispatch(registerSuccess());
  }, []);
  if (auth.uid) {
    return <Redirect to="/fan/search-player" />;
  }
  if (auth.uid && location.search === "?redirect=athleteBlogs") {
    return <Redirect to="/athlete-blogs" />;
  }

  return (
    <>
      <div className="text-center mt-5">
        <a href="https://fans-help-players-athlete.web.app/">
          <img src={Logo} alt="logo" className="logo" />
        </a>
      </div>
      <Form
        onSubmit={(e) => {
          e.preventDefault();
          let creds = {
            email: email,
            password: password,
          };
          dispatch(
            login(creds, () => {
              if (location.search === "?redirect=athleteBlogs") {
                history.push("/athlete-blogs");
              }
            })
          );
        }}
      >
        <div className="auth-card ">
          <h2 className="auth-heading">Fan Login</h2>
          <Label className="mt-3 auth-label">
            <b>Email</b>
          </Label>
          <Input
            required
            placeholder="name@gmail.com"
            type="email"
            className=" custom-input"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <Label className="mt-5 auth-label" type="password">
            <b>Password</b>
          </Label>
          <Input
            required
            placeholder="Your Password"
            className=" custom-input"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
          <div className="d-flex mt-4">
            <Label className="ml-auto auth-label">
              <Link to="/auth/forgot-password">
                <u>Forgot Password?</u>
              </Link>
            </Label>
          </div>
        </div>
        <div className="text-center">
          <Button className="auth-button mt-5" disabled={!email || !password}>
            {auth.loading ? <Spinner size="sm" /> : " Log In"}
          </Button>
        </div>
      </Form>
      <div className="mt-3 mx-0 mx-md-5 text-center">
        <Label className="auth-label">Don't have an account yet?</Label>{" "}
        <Link to="/auth/register">
          <Label
            className="text-primary auth-label"
            style={{ cursor: "pointer" }}
          >
            {" "}
            <b>
              <u>Sign Up</u>
            </b>
          </Label>
        </Link>
      </div>
    </>
  );
}

export default Login;
